import { render, staticRenderFns } from "./StockPhotos.vue?vue&type=template&id=681d0747&scoped=true"
import script from "./StockPhotos.vue?vue&type=script&lang=js"
export * from "./StockPhotos.vue?vue&type=script&lang=js"
import style0 from "./StockPhotos.vue?vue&type=style&index=0&id=681d0747&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681d0747",
  null
  
)

export default component.exports